import React, { useState } from "react";

export default function Filter({ filters, setFilters }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ marginTop: 16, marginBottom: 16 }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: "#0B74FF",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: "25px",
          cursor: "pointer",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}
      >
        🔍 Advanced Filters {isOpen ? "▲" : "▼"}
      </button>

      {isOpen && (
        <div style={{
          marginTop: 10,
          padding: 20,
          background: "#f8f9fa",
          borderRadius: 10,
          border: "1px solid #dee2e6",
          display: "flex",
          gap: 20,
          alignItems: "center",
          flexWrap: "wrap"
        }}>
          <div>
            <label style={{ fontWeight: "bold", marginRight: 8 }}>Search Radius (km):</label>
            <input
              type="number"
              min="10"
              max="500"
              value={filters.radius || 20}  // ✅ Default to 100
              onChange={(e) => setFilters((f) => ({ ...f, radius: e.target.value }))}
              style={{
                padding: "8px",
                borderRadius: 5,
                border: "1px solid #ccc",
                width: 80
              }}
            />
          </div>
          {/* Add more filters here if needed, e.g., vehicle type */}
        </div>
      )}
    </div>
  );
}